module.exports = __webpack_public_path__ + "img/ss.67001d2a.svg";